import Swal from "sweetalert2";
import { RemoteConstants } from "../../../data/remote/RemoteConstants";
import { UIActions } from "../../../presentation/redux/actions/UIActions";
import { sessionLocalRepo } from "../../../di/repo_module";

export const validate2fa = async (token, code, tmpData, dispatch, iniciarSesion) => {
  try {
    const params = new URLSearchParams({
      token: token,
      code: code
    });
    const peticion = await fetch(`${RemoteConstants.BASE_URL}pos/validate/2fa/code?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(resp => {
        return resp.json();
      })
      .then(data => {
        if (data.code === 'OK') {
          sessionLocalRepo().setSession(tmpData);
					iniciarSesion(tmpData);
        } else {
          Swal.fire('Error', data.userMessage, 'error');
        }
      });
  } catch (error) {
    Swal.fire('Error', error, 'error');
  }
  dispatch(UIActions.uiLoadInactive());
}